const level1 = ["#53ADF6", "#D0D0D0", "#D0D0D0", "#D0D0D0", "#D0D0D0"];
const level2 = ["#83D376", "#83D376", "#D0D0D0", "#D0D0D0", "#D0D0D0"];
const level3 = ["#F5D254", "#F5D254", "#F5D254", "#D0D0D0", "#D0D0D0"];
const level4 = ["#FF7D05", "#FF7D05", "#FF7D05", "#FF7D05", "#D0D0D0"];
const level5 = ["#F22B29", "#F22B29", "#F22B29", "#F22B29", "#F22B29"];
export { level1, level2, level3, level4, level5 };
